export default __webpack_public_path__ + "static/audio-cardio-6-c-fdaf6c968adba3c35f2bb44aae25f683.webp";